import { PhotoLayoutComponent } from './photo-layout.component';
import { ButtonModule } from '../button/button.module';
import { SharedModule } from '@shared/shared.module';
import { NgModule } from '@angular/core';

@NgModule({
	declarations: [PhotoLayoutComponent],
	imports: [SharedModule, ButtonModule],
	exports: [PhotoLayoutComponent],
})
export class PhotoLayoutModule {}
